import { render, staticRenderFns } from "./GradeRuleEditSlidebar.vue?vue&type=template&id=7450ed60"
import script from "./GradeRuleEditSlidebar.vue?vue&type=script&lang=js"
export * from "./GradeRuleEditSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports